import React from "react";
import moment from "moment";

export default ({ timeSlot, onClick }) => {
  return (
    <div
      className="timeslot-item"
      onClick={() => {
        onClick(timeSlot);
      }}
    >
      {`${moment
        .parseZone(timeSlot.startDateTime)
        .format("hh:mm a")
        .toUpperCase()} - ${moment
        .parseZone(timeSlot.endDateTime)
        .format("hh:mm a")
        .toUpperCase()}`}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/TimeSlot.js